import React from 'react';

const DedupTransactionModal = ({ isOpen, onClose, groupData, dedupLevel }) => {
  if (!isOpen || !groupData) return null;

  const formatTimestamp = (timestamp) => {
    const date = new Date(timestamp);
    return date.toLocaleString();
  };

  const getActionDisplay = (action) => {
    const actionMap = {
      'address_to_digipin': 'Address → DigiPin',
      'digipin_to_address': 'DigiPin → Address',
      'coordinates_to_digipin': 'Coordinates → DigiPin',
      'latlng_to_address_digipin': 'Lat/Lng → Address & DigiPin',
      'reverse': 'Reverse Geocode',
      'lookup': 'DigiPin Lookup'
    };
    return actionMap[action] || action;
  };

  const getSourceDisplay = (source) => {
    const sourceMap = {
      'web_app': 'Web App',
      'bulk_upload': 'Bulk Upload',
      'combined_digipin': 'Combined Search',
      'poi_click': 'POI Click'
    };
    return sourceMap[source] || source;
  };

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 1000
    }}>
      <div style={{
        backgroundColor: 'white',
        borderRadius: '8px',
        padding: '24px',
        maxWidth: '90vw',
        maxHeight: '90vh',
        overflow: 'auto',
        boxShadow: '0 4px 20px rgba(0, 0, 0, 0.15)'
      }}>
        {/* Header */}
        <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginBottom: '20px',
          borderBottom: '1px solid #dee2e6',
          paddingBottom: '12px'
        }}>
          <div>
            <h2 style={{
              margin: 0,
              fontSize: '18px',
              fontWeight: '600',
              color: '#495057'
            }}>
              Search Transactions
            </h2>
            <p style={{
              margin: '4px 0 0 0',
              fontSize: '14px',
              color: '#6c757d'
            }}>
              DigiPin Level {dedupLevel}: {groupData.digipin_prefix}
            </p>
            <p style={{
              margin: '4px 0 0 0',
              fontSize: '12px',
              color: '#6c757d'
            }}>
              {groupData.count} searches in this area
            </p>
          </div>
          <button
            onClick={onClose}
            style={{
              background: 'none',
              border: 'none',
              fontSize: '24px',
              cursor: 'pointer',
              color: '#6c757d',
              padding: '4px',
              borderRadius: '4px',
              width: '32px',
              height: '32px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
          >
            ×
          </button>
        </div>

        {/* Transactions Table */}
        <div style={{
          maxHeight: '60vh',
          overflow: 'auto',
          border: '1px solid #dee2e6',
          borderRadius: '4px'
        }}>
          <table style={{
            width: '100%',
            borderCollapse: 'collapse',
            fontSize: '13px'
          }}>
            <thead style={{
              backgroundColor: '#f8f9fa',
              position: 'sticky',
              top: 0,
              zIndex: 1
            }}>
              <tr>
                <th style={{
                  padding: '12px 8px',
                  textAlign: 'left',
                  borderBottom: '1px solid #dee2e6',
                  fontWeight: '600',
                  color: '#495057',
                  fontSize: '12px'
                }}>
                  Time
                </th>
                <th style={{
                  padding: '12px 8px',
                  textAlign: 'left',
                  borderBottom: '1px solid #dee2e6',
                  fontWeight: '600',
                  color: '#495057',
                  fontSize: '12px'
                }}>
                  Address
                </th>
                <th style={{
                  padding: '12px 8px',
                  textAlign: 'left',
                  borderBottom: '1px solid #dee2e6',
                  fontWeight: '600',
                  color: '#495057',
                  fontSize: '12px'
                }}>
                  DigiPin
                </th>
                <th style={{
                  padding: '12px 8px',
                  textAlign: 'left',
                  borderBottom: '1px solid #dee2e6',
                  fontWeight: '600',
                  color: '#495057',
                  fontSize: '12px'
                }}>
                  Action
                </th>
                <th style={{
                  padding: '12px 8px',
                  textAlign: 'left',
                  borderBottom: '1px solid #dee2e6',
                  fontWeight: '600',
                  color: '#495057',
                  fontSize: '12px'
                }}>
                  Source
                </th>
              </tr>
            </thead>
            <tbody>
              {groupData.transactions.map((transaction, index) => (
                <tr key={index} style={{
                  backgroundColor: index % 2 === 0 ? '#ffffff' : '#f8f9fa',
                  borderBottom: '1px solid #f1f3f4'
                }}>
                  <td style={{
                    padding: '10px 8px',
                    fontSize: '12px',
                    color: '#6c757d',
                    whiteSpace: 'nowrap'
                  }}>
                    {formatTimestamp(transaction.timestamp)}
                  </td>
                  <td style={{
                    padding: '10px 8px',
                    fontSize: '12px',
                    color: '#495057',
                    maxWidth: '200px',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap'
                  }} title={transaction.address}>
                    {transaction.address || 'N/A'}
                  </td>
                  <td style={{
                    padding: '10px 8px',
                    fontSize: '12px',
                    color: '#495057',
                    fontfamily: 'monospace',
                    fontWeight: '500'
                  }}>
                    {transaction.digipin || 'N/A'}
                  </td>
                  <td style={{
                    padding: '10px 8px',
                    fontSize: '12px',
                    color: '#495057'
                  }}>
                    {getActionDisplay(transaction.action)}
                  </td>
                  <td style={{
                    padding: '10px 8px',
                    fontSize: '12px',
                    color: '#6c757d'
                  }}>
                    {getSourceDisplay(transaction.source)}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Footer */}
        <div style={{
          marginTop: '16px',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          fontSize: '12px',
          color: '#6c757d'
        }}>
          <span>
            Showing {groupData.transactions.length} transactions
          </span>
          <button
            onClick={onClose}
            style={{
              backgroundColor: '#6c757d',
              color: 'white',
              border: 'none',
              padding: '8px 16px',
              borderRadius: '4px',
              cursor: 'pointer',
              fontSize: '13px'
            }}
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default DedupTransactionModal;
